import React from 'react'

import Form from './Form'

const Index = ({ onClose }: { onClose: () => void }): JSX.Element => {
  return <Form onCloseModal={onClose} />
}

export default Index
